export { default } from "./SearchResults";
export { RESULTS_PER_PAGE } from "./SearchResults";
